import {
  InfoToCollect,
  Step as ModelStep,
} from "@redotech/redo-model/return-flow";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import QuestionIcon from "@redotech/redo-web/icon-old/question.svg";
import { produce } from "immer";
import * as React from "react";
import {
  StepDownstream,
  StepId,
  StepType,
  StepTypeDetailsProps,
} from "../step";
import { containsImg } from "./step-rich-text-util";

export interface CustomerResponseState {
  next: StepId | undefined;
  message: string;
  messageHtml?: string;
  attempted?: boolean;
  infoToCollect: InfoToCollect;
  customTitle?: string;
}

export const CUSTOMER_RESPONSE = (
  Details: React.ComponentType<StepTypeDetailsProps<CustomerResponseState>>,
): StepType<CustomerResponseState, ModelStep.CustomerResponse> => ({
  Details: (props: StepTypeDetailsProps<CustomerResponseState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  title: "Customer response",
  valid(state) {
    return (
      state.next !== undefined &&
      !!state.message &&
      !containsImg(state.messageHtml)
    );
  },
  Icon: QuestionIcon,
  description(state) {
    return state.message;
  },
  downstream(state) {
    const result: StepDownstream[] = [];
    if (state.next !== undefined) {
      result.push({ id: state.next });
    }
    return result;
  },
  maxDownstream() {
    return 1;
  },

  layout() {
    return BlockLayout.FULL;
  },
  empty: {
    message: "",
    messageHtml: undefined,
    next: undefined,
    infoToCollect: InfoToCollect.CUSTOM,
  },
  stepDeleted(state, stepId) {
    return produce(state, (state) => {
      if (state.next === stepId) {
        state.next = undefined;
      }
    });
  },
  toModel(state, id) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.CUSTOMER_RESPONSE,
      next: id(state.next!),
      message: state.message,
      messageHtml: state.messageHtml,
      infoToCollect: state.infoToCollect,
    };
  },
  fromModel(model, id) {
    return {
      customTitle: model.customTitle,
      next: id(model.next),
      message: model.message,
      messageHtml: model.messageHtml,
      infoToCollect: model.infoToCollect,
    };
  },
});
